import './Avatar.scss'

import React, { useCallback, useEffect, useState } from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'

const SIZES = {
  'small': 24,
  'field-sized': 32,
  'default': 40,
  'medium': 56,
  'large': 72
}

const Avatar = ({ size, source, alternative }) => {
  const invalidSource = !source || source.length === 0
  const [renderElement, setRenderElement] = useState(
    invalidSource && generateAlternative(alternative)
  )
  const avatarSize = SIZES[size] || SIZES['default']
  const largeText = SIZES[size] > 40

  const onError = useCallback(
    () => setRenderElement(generateAlternative(alternative)),
    [alternative]
  )

  useEffect(() => {
    setRenderElement(invalidSource && generateAlternative(alternative))
  }, [invalidSource, alternative])

  return (
    <div
      className={classNames('avatar', {
        'paragraph-default-basic': !largeText,
        'paragraph-extra-large-basic': largeText
      })}
      style={{ width: avatarSize, height: avatarSize }}
    >
      {invalidSource || renderElement ? (
        renderElement
      ) : (
        <img
          style={{ maxWidth: avatarSize, maxHeight: avatarSize }}
          alt=''
          src={source}
          onError={onError}
        />
      )}
    </div>
  )
}

const generateAlternative = (alternative) => {
  if (alternative) {
    if (typeof alternative === 'string') {
      return <div className='-initials'>{getInitials(alternative)}</div>
    } else {
      return alternative
    }
  } else {
    return ''
  }
}

const getInitials = (name) => {
  if (!name) return ''
  const parts = name.trim().split(/[ ]+/)
  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase()
  } else {
    return (parts[0][0] + parts[1][0]).toUpperCase()
  }
}

Avatar.propTypes = {
  source: PropTypes.string,
  size: PropTypes.oneOf(['small', 'field-sized', 'default', 'medium', 'large']),
  alternative: PropTypes.string
}

Avatar.defaultProps = {
  size: 'default'
}

export default Avatar
